<template>
  <div
    :class="[color, `text-${size}`, 'pointer-events-none inline-flex w-20 justify-center rounded px-3 py-2']"
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'bg-gray-300',
    },
    size: {
      type: String,
      default: 'xs',
    },
  },
}
</script>
